type EventProps = Record<string, unknown>;

let posthogPromise: Promise<typeof import('posthog-js').default> | null = null;

function loadPosthog() {
  if (typeof window === 'undefined') return null;
  if (!posthogPromise) {
    posthogPromise = import('posthog-js').then((m) => m.default);
  }
  return posthogPromise;
}

export async function track(event: string, properties?: EventProps): Promise<void> {
  try {
    const posthog = await loadPosthog();
    if (!posthog) return;
    posthog.capture(event, properties);
  } catch {
    // analytics must never break the UI
  }
}

export async function identify(distinctId: string, properties?: EventProps): Promise<void> {
  try {
    const posthog = await loadPosthog();
    if (!posthog) return;
    posthog.identify(distinctId, properties);
  } catch {
    // analytics must never break the UI
  }
}

export async function getDistinctId(): Promise<string | null> {
  try {
    const posthog = await loadPosthog();
    if (!posthog) return null;
    return posthog.get_distinct_id?.() ?? null;
  } catch {
    return null;
  }
}
